import { GET_RECORDING_DATA_SUCCESS, GET_RECORDING_DATA_FAILURE, LOAD_RECORDING_IMAGES_SUCCESS } from './actions';

const initialState = {
  getRecordingDataResult: {
    success: true,
  },
  recordingData: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_RECORDING_DATA_SUCCESS:
      return { ...state, getRecordingDataResult: { success: true }, recordingData: action.payload.recordingData };
    case GET_RECORDING_DATA_FAILURE:
      return { ...state, getRecordingDataResult: { success: false, ...action.payload.error }, recordingData: null };
    case LOAD_RECORDING_IMAGES_SUCCESS:
      return { ...state, getRecordingDataResult: { success: true }, recordingData: action.payload.recordingData };
    default:
      return state;
  }
};

export default reducer;
